import React, { Component } from "react";
import { Flex } from "rebass";
import { connect } from "../../utils";
import ContainerDimensions from "react-container-dimensions";
import { RestApiProductList } from "../../../../../restClient";
import { ProductCard } from "../../../components";

class ProductListView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: [],
      productsContent: []
    };
    this.getProductList();
  }
  componentWillUnmount() {
    this.unmounting = true;
  }

  getProductList = () => {
    const { id, layoutState } = this.props;
    const { list } = layoutState.getItemJS(id).props.values;
    let newValue = [];
    if (Array.isArray(list)) {
      newValue = list;
    }
    let params = newValue.join();
    const url = "/products?collections=" + params;
    RestApiProductList(url)
      .then(response => {
        return response.json();
      })
      .then(items => {
        // this is for check unmounting components
        if (this.unmounting) {
          return;
        }
        if (items && !items.messages) {
          let newItems = [];
          for (var i = 0; i < items.length; ++i) {
            for (var j = 0; j < items[i].products.length; ++j)
              newItems.push(items[i].products[j]);
          }
          this.setState({ productsContent: newItems });
          //this.setState({ productsContent: items });
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  render() {
    const { id, layoutState } = this.props;
    const { containerPadding, showPrice } = layoutState.getItemJS(
      id
    ).props.values;

    return (
      <div
        style={{
          boxSizing: "border-box",
          position: "relative",
          height: "100%",
          display: "flex",
          padding: containerPadding,
          flex: 1
        }}
      >
        <ContainerDimensions>
          {({ width, height }) => {
            return (
              <Flex
                wrap
                ml={["0px", "0px", "0px", checkWidthMargin(width)]}
                flex={["1"]}
              >
                {this.state.productsContent &&
                  this.state.productsContent.length > 0 &&
                  this.state.productsContent.map((product, index) => {
                    return (
                      <BoxCase
                        key={`box${index}`}
                        px={["4px", "4px", "4px", checkWidthPadding(width)]}
                        py={["4px"]}
                        w={[checkWidthPercent(width)]}
                      >
                        <ProductCard
                          product={product}
                          itemWidth={checkWidth(width)}
                          showPrice={showPrice}
                        />
                      </BoxCase>
                    );
                  })}
              </Flex>
            );
          }}
        </ContainerDimensions>
      </div>
    );
  }
}

// const checkWidth = width => {
//   let result = width - 16;
//   if (width > 480 && width <= 600) {
//     result = width / 2 - 18;
//   } else if (width > 600 && width <= 768) {
//     result = width / 3 - 16;
//   } else if (width > 768) {
//     result = width / 4 - 16;
//   }
//   return result;
// };
const checkWidth = width => {
  let result = width / 2 - 8;
  if (width > 480 && width <= 639) {
    result = width / 2 - 8;
  } else if (width > 639 && width <= 831) {
    result = width / 3 - 8;
  } else if (width > 831) {
    result = width / 4;
  }
  return result;
};

const checkWidthPercent = width => {
  let result = "50%";
  if (width > 480 && width <= 639) {
    result = "50%";
  } else if (width > 639 && width <= 831) {
    result = "33.3333333%";
  } else if (width > 831) {
    result = "25%";
  }
  return result;
};

const checkWidthMargin = width => {
  let result = "0px";
  if (width > 831) {
    result = "-8px";
  }
  return result;
};

const checkWidthPadding = width => {
  let result = "4px";
  if (width > 831) {
    result = "8px";
  }
  return result;
};

export default connect("layoutState")(ProductListView);

const BoxCase = Flex.extend`
  position: relative;
  overflow: hidden;
  /* @media screen and (min-width: 52em) {
    width: 25%;
  } */
`;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/ProductListView.js